module.exports = {
  carrier: [
    {
      type: 'pending_tasks',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'offer_received',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'new_shipment_assigned',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'cfs_shipment',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_origin',
      email: { silent: true, recipients: [], hidden: true },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_origin',
      email: { silent: true, recipients: [], hidden: true },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'picked_up_shipment',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'en_route',
      email: { silent: true, recipients: [], hidden: true },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_destination',
      email: { silent: true, recipients: [], hidden: true },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_destination',
      email: { silent: true, recipients: [], hidden: true },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'delivered',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'job_complete',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'carrier_batch_payout',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'bol_reminder',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_carrier_batch_payout',
      email: { silent: false, recipients: [], hidden: true },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_delivery_order_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_accessorial_requests',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_missing_documentation_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'new_request',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'status_changed',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'new_comment',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_new_shipment_assigned',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_do_cancellation',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_new_shipment_offered',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_empty_ready_pickup',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_rate_card',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
  ],

  admin: [
    {
      type: 'new_user',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'new_offer',
      email: { silent: false, recipients: [] },
      text: { silent: false, recipients: [] },
    },
    {
      type: 'new_shipment_assigned',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'offer_exposed',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'offer_accepted',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_origin',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_origin',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'picked_up_shipment',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'en_route',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_destination',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_destination',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'delivered',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'job_complete',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'job_canceled',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'shipper_batch_invoice',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'shipper_batch_receipt',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'card_declined',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'carrier_batch_payout',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'wait_time_warning',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_shipper_batch_invoice',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_shipper_batch_receipt',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_card_declined',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_wait_time_warning',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_delivery_order_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_missing_documentation_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_new_shipment_assigned',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_do_cancellation',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_new_shipment_offered',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_proof_of_delivery',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_empty_ready_pickup',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_rate_card',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
  ],

  shipper: [
    {
      type: 'new_offer',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'offer_accepted',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_origin',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_origin',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'picked_up_shipment',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'en_route',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arriving_at_destination',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'arrived_at_destination',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'delivered',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'job_complete',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'shipper_batch_invoice',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'shipper_batch_receipt',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'card_declined',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'wait_time_warning',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'drayage_shipper_batch_invoice',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_accessorial_requests',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_wait_time_warning',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_shipper_batch_receipt',
      email: { silent: false, recipients: [], hidden: true },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_card_declined',
      email: { silent: false, recipients: [], hidden: true },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'bill_of_lading_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'rate_confirmation_contacts',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_proof_of_delivery',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
    {
      type: 'drayage_rate_card',
      email: { silent: false, recipients: [] },
      text: { silent: true, recipients: [], hidden: true },
    },
  ],

  consignee: [
    {
      type: 'new_request',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'status_changed',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
    {
      type: 'new_comment',
      email: { silent: true, recipients: [] },
      text: { silent: true, recipients: [] },
    },
  ],
};
